import React from "react";
import PropTypes from "prop-types";
import radium from "radium";
import BookmarkListMenu from "backpack-ui/dist/components/bookmarkListMenu";
import BookmarkListMenuOption from "backpack-ui/dist/components/bookmarkListMenu/option";
import ShareSettings from "backpack-ui/dist/components/shareMenu/shareSettings";
import styles from "../styles";

const ShareButton = ({ shareText, getPoiUrl, showToast }) => {
  const shareContent = {
    text: shareText,
    url: `https://www.lonelyplanet.com${getPoiUrl()}`,
    via: "lonelyplanet",
  };

  return (
    <BookmarkListMenu
      iconName="Share"
      iconLabel="Share"
      reveal
      style={styles.bookmarksMenu}
    >
      <ShareSettings
        shareContent={shareContent}
        handleClipboardSuccess={() => showToast("Sucessfully copied to clipboard")}
        handleClipboardError={() => showToast("There was an error, please copy URL manually", "error")}
      >
        {(shareActions, __, ClipboardWrapper) => (
          <span>
            <BookmarkListMenuOption
              onClick={() => shareActions.twitter()}
            >
              Share on Twitter
            </BookmarkListMenuOption>

            <BookmarkListMenuOption
              onClick={() => shareActions.facebook()}
            >
              Share on Facebook
            </BookmarkListMenuOption>

            <ClipboardWrapper text={shareContent.url}>
              <BookmarkListMenuOption onClick={() => null}>
                Copy link
              </BookmarkListMenuOption>
            </ClipboardWrapper>
          </span>
        )}
      </ShareSettings>
    </BookmarkListMenu>
  );
};

ShareButton.propTypes = {
  shareText: PropTypes.string,
  getPoiUrl: PropTypes.func,
  showToast: PropTypes.func,
};

ShareButton.styles = styles;

export default radium(ShareButton);



// WEBPACK FOOTER //
// ./assets/pois/components/shareButton/index.jsx